import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import drone2 from "../../assets/drone2.svg";
import vertical_shot_buildings1 from "../../assets/verticalshotcity_sidebarBackground.svg";
import New_Logo from "../../assets/New_Logo.svg";
import latestLogo from "../../assets/latestLogo.svg";
import FromInput from "./FormInput";
import Loader from "../../components/shared/Loader";
import { api } from "../../utils/api";
import { useToast } from "../../components/shared/ToastProvider";
import DroneS from "../../assets/drone2.svg";
import { useTranslation } from "react-i18next";
import { API_ROUTES } from "../../routes/apiRoutes";
import { LanguageDropdown } from "../../components/shared/LanguageDropdown";

// Validation schema
const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  password: Yup.string()
    .min(4, "Password must be at least 4 characters")
    .required("Password is required"),
});

const Login = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useContext(AuthContext);
  const { addToast } = useToast();

  const { i18n } = useTranslation();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard/");
    }
  }, [isAuthenticated, navigate]);
  const handleOnSubmit = (values, { setSubmitting }) => {
    api({
      method: "POST",
      url: API_ROUTES.LOGIN,
      data: values,
    })
      .then((response) => {
        setSubmitting(false);

        const data = response?.data?.data;

        login(data);

        const isContractorUser =
          typeof data?.user_type === "string" &&
          data.user_type.startsWith("contractor_");

        if (isContractorUser && data?.is_profile_completed === false) {
          // Redirect to onboarding
          return navigate("/onboard/contractor");
        }

        // Redirect to dashboard
        navigate("/dashboard");
      })
      .catch((error) => {
        addToast(
          error?.response?.data?.message ||
            error?.response?.data?.errors ||
            "Invalid credentials",
          "error",
        );
        setSubmitting(false);
      });
  };

  return (
    <div className="font-sans h-screen flex lg:flex-row flex-wrap bg-[#F6FBFF] overflow-hidden">
      <div className="hidden md:block relative w-1/2 h-screen overflow-hidden">
        <div className="absolute inset-0 clip-hero-light"></div>
        <div className="absolute left-[-50px] inset-0 clip-hero w-full h-full">
          <img
            src={vertical_shot_buildings1}
            alt="Cover_Image"
            className="w-full h-full object-cover opacity-100"
          />

          {/* <div className="absolute inset-0 bg-black-500 opacity-5"></div> */}
          <div className="absolute top-[5%] left-[15%]">
            <img src={New_Logo} className="w-[100px] md:w-[120px]" />
          </div>

          <div className="absolute top-[28%] left-[12%] md:left-[15%] w-[90%] md:w-[60%]">
            <h2 className="text-md md:text-xl lg:text-2xl font-medium mb-4 leading-relaxed">
              <span className="text-[#2E6243] text-[20px]">
                {i18n.language === "en"
                  ? "Get Started with "
                  : "Kom i gang med "}
              </span>
              <span className="text-[24px] text-black font-semibold">
                AssetEye
              </span>
            </h2>
            <p className="text-[16px] text-black">
              {i18n.language === "en"
                ? "Next-Gen Drone Solutions for Detecting Structural Damage and Estimating Repair Costs. "
                : "Næste generations droneløsninger til detektering af strukturelle skader og estimering af reparationsomkostninger. "}
            </p>
          </div>

          <img
            src={DroneS}
            alt="Drone"
            className="absolute left-[-18%] bottom-[-10%] w-[70%] max-w-[505px] object-contain scale-x-[-1]"
          />
        </div>
      </div>

      <div className="w-full md:w-1/2 flex flex-col px-3 justify-center items-center bg-[#F6FBFF] relative overflow-hidden">
        <div className="absolute top-4 right-4">
          <LanguageDropdown />
        </div>

        <img src={latestLogo} alt="Logo" className="w-[53px] h-[53px] mb-4" />

        <h1 className="text-[26px] font-bold text-center">
          {i18n.language === "en" ? "Welcome to " : "Velkommen til "}
          <span className="text-[#2E6243]">AssetEye</span>
        </h1>

        <p className="text-[12px] text-[#73787E] text-center">
          {i18n.language === "en"
            ? "Enter your credentials to access your account "
            : "Indtast dine loginoplysninger for at få adgang til din konto "}
        </p>

        <div className="w-[24rem] mt-3">
          <Formik
            initialValues={{ email: "", password: "" }}
            validationSchema={validationSchema}
            onSubmit={handleOnSubmit}
          >
            {({ isSubmitting }) => (
              <Form className="px-3">
                <FromInput
                  label={i18n.language === "en" ? "Email" : "E-mail"}
                  id="email"
                  type="text"
                  name="email"
                  placeholder="Enter your Email Address"
                  icon="person"
                />
                <FromInput
                  label={i18n.language === "en" ? "Password" : "Adgangskode"}
                  id="password"
                  type="password"
                  name="password"
                  placeholder="Enter password"
                  icon="key"
                />
                <a
                  href="/forget-password"
                  className="text-[10px] text-[#132145] flex justify-end mb-2 underline"
                >
                  {i18n.language === "en"
                    ? "Forgot password?"
                    : "Glemt adgangskode?"}
                </a>
                <button
                  className="w-full bg-secondaryColor hover:bg-secondaryColor/90 text-white text-[12px] py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  {i18n.language === "en" ? "Login" : "Log ind"}
                </button>
                {/* <a
                  href="/signup"
                  className="text-[14px] text-[#132145] flex justify-center mt-2"
                >
                  Don't have an account?
                  <span className="text-customgreen font-normal">
                    &nbsp;Sign Up as Client
                  </span>
                </a>
                <a
                  href="/signup/contractor"
                  className="text-[14px] text-[#132145] flex justify-center mt-2"
                >
                  <span className="text-customgreen font-normal">Sign Up as Contractor</span>
                  <span className="text-customgreen font-normal">
                    Sign Up as Contractor
                  </span>
                  <span className="text-customgreen font-normal">Sign Up as Contractor</span>
                </a> */}

                <img
                  src={drone2}
                  alt="Drone"
                  className="absolute right-[-4%] bottom-[-20%] w-[90%] max-w-[450px] opacity-10 pointer-events-none"
                />

                {isSubmitting && <Loader />}
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Login;
